import { authHeader } from '_helpers';

export function getAllHeadersWithAuth() {
    let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Authorization', authHeader().Authorization );

    return headers
}